import React from 'react'
import FieldWrapper from '../Common/FieldWrapper'

import DatePicker from '../Common/DatePicker'
import TimePicker from '../Common/TimePicker'

import moment from 'moment'
import 'moment/locale/nl'
import 'moment/locale/en-gb'
import 'moment/locale/de'

export default class DateAndTime extends FieldWrapper {
  defaultDateFormat = 'DD-MM-YYYY'
  defaultTimeFormat = 'HH:mm'
  defaultSplitter = '|'

  getDefaultFormat() {
    const { splitter = this.defaultSplitter } = this.props.config
    return `${this.defaultDateFormat}${splitter}${this.defaultTimeFormat}`
  }

  getValueFormat() {
    const { valueFormat, inputFormat } = this.props.config
    return valueFormat || inputFormat || this.getDefaultFormat()
  }

  getFormats(format) {
    const { splitter = this.defaultSplitter } = this.props.config

    const formats = format.split(splitter)
    return {
      date: formats.length > 0 ? formats[0] : this.defaultDateFormat,
      time: formats.length > 1 ? formats[1] : this.defaultTimeFormat,
    }
  }

  getValueFormats() {
    const format = this.getValueFormat()
    return this.getFormats(format)
  }

  getInputFormats() {
    const { inputFormat } = this.props.config

    const format = inputFormat || this.getDefaultFormat()
    return this.getFormats(format)
  }

  getDisplayFormats() {
    const { displayFormat, splitter = this.defaultSplitter } = this.props.config

    if (displayFormat)
      return this.getFormats(displayFormat)

    const value = this.props.formikField.value
    const valueFormat = this.getValueFormat()
    const isThisYear = value && moment(value, valueFormat, true).year() === moment().year()
    const dateFormat = isThisYear ? "dd D MMM" : "dd D MMM YYYY"
    return `${dateFormat}${splitter}${this.defaultTimeFormat}`
  }

  getValues() {
    const {
      formikField,
      config: { splitter = this.defaultSplitter }
    } = this.props

    const valueFormats = this.getValueFormats()
    const value = (formikField.value) ? formikField.value : ''
    const values = value.split(splitter)
    return {
      date: moment(values[0], valueFormats.date).isValid() ? values[0] : null,
      time: moment(values[1], valueFormats.time).isValid() ? values[1] : null,
    }
  }

  getSplitted(value) {
    const { splitter = this.defaultSplitter } = this.props.config

    return {
      date: value.split(splitter)[0],
      time: value.split(splitter)[1]
    }
  }

  getRuleDate(type) {
    const { validation } = this.props.config

    if (!validation || !validation.rules)
      return null

    const rule = validation.rules.find(rule => rule.type === type)
    if (!rule || !rule.params || !rule.params[0])
      return null

    const format = this.getValueFormats().date
    const param = this.getSplitted(rule.params[0] || []).date
    const formatted = moment(param, format, true)
    return (formatted && formatted.isValid()) ? formatted : null
  }

  renderField() {
    const { config, isRequired } = this.props
    const { label, name, placeholder, locale, readOnly, disabled } = config

    moment.locale(locale || 'en-gb')
    const minDate = this.getRuleDate('min')
    const maxDate = this.getRuleDate('max')
    const valueFormats = this.getValueFormats()
    const inputFormats = this.getInputFormats()
    const displayFormats = this.getDisplayFormats()
    const placeholders = this.getSplitted(placeholder)
    const values = this.getValues()

    var render = (
      <div className="field__date-and-time">
        <div className="field__input-container">
          <div className="field__input field__input--date">
            <DatePicker
              label={label}
              name={`${name}-date`}
              value={values.date}
              minDate={minDate}
              maxDate={maxDate}
              valueFormat={valueFormats.date}
              inputFormat={inputFormats.date}
              displayFormat={displayFormats.date}
              placeholder={placeholders.date}
              locale={locale}
              //className="react-datepicker"
              readOnly={readOnly}
              disabled={!!disabled}
              aria-required={!!isRequired}
              onChange={this.onDateChange}
              onBlur={this.onDateBlur}
              onFocus={this.onDateFocus}
            />
          </div>
        </div>
        <div className="field__input-container">
          <div className="field__input field__input--time">
            <TimePicker
              label={label}
              className="field__time"
              name={`${name}-time`}
              value={values.time}
              /* minDate={minDate}
              maxDate={maxDate} */
              valueFormat={valueFormats.time}
              inputFormat={inputFormats.time}
              displayFormat={displayFormats.time}
              placeholder={placeholders.time}
              locale={locale}
              //className="react-datepicker"
              readOnly={readOnly}
              disabled={!!disabled}
              aria-required={!!isRequired}
              onChange={this.onTimeChange}
              onBlur={this.onTimeBlur}
              onFocus={this.onTimeFocus}

              timeIntervals={30}
            />
          </div>
        </div>
      </div>
    )

    return render
  }

  setDateValue(date) {
    const {
      formikForm, formikField,
      config: { splitter = this.defaultSplitter }
    } = this.props

    const values = this.getValues()
    const newValue = `${date}${splitter}${values.time || ''}`
    formikForm.setFieldValue(formikField.name, newValue, true)
  }

  setTimeValue(time) {
    const {
      formikForm, formikField,
      config: { splitter = this.defaultSplitter }
    } = this.props

    const values = this.getValues()
    const newValue = `${values.date || ''}${splitter}${time}`
    formikForm.setFieldValue(formikField.name, newValue, true)
  }

  onDateChange = (date) => {
    const values = this.getValues()
    if (date === values.date)
      return this.onDateFocus()

    this.setDateValue(date)

    this.onDateFocus()
  }
  onDateBlur = (e) => {
    const { formikForm, formikField } = this.props
    this.setState({
      dateFocused: false
    })

    const values = this.getValues()
    if (values.time)
      formikForm.setFieldTouched(formikField.name, true)
  }
  onDateFocus = (e) => {
    this.setState({
      dateFocused: true
    })
  }

  onTimeChange = (time) => {
    const values = this.getValues()
    if (time === values.time)
      return this.onTimeBlur()

    this.setTimeValue(time)
  }
  onTimeBlur = (e) => {
    const { formikForm, formikField } = this.props
    this.setState({
      timeFocused: true
    })
    const values = this.getValues()
    if (values.date)
      formikForm.setFieldTouched(formikField.name, true)
  }
  onTimeFocus = (e) => {
    this.setState({
      timeFocused: false
    })
    if (e)
      this.props.formikField.onBlur(e)
  }
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/DateAndTime.js